import { create } from "zustand";

/** Body of the structured 409 the backend emits when a non-walk-in
 *  reservation lands in the staff-only after-hours extension window
 *  without ``acknowledge_after_hours_override``.
 *
 *  Mirrors ``backend/apps/reservations/services/validation.py::
 *  after_hours_override_body``. The staff client uses these fields to
 *  render the confirmation prompt and decide whether to retry with the
 *  flag set. */
export interface AfterHoursContext {
  slot_local_time: string;
  slot_local_ends_time: string;
  slot_local_date: string;
  public_close_time: string | null;
  extension_minutes: number;
  /** ``true`` cuando el inicio mismo cae después del cierre público
   *  (e.g. una reserva 23:30-00:30 con cierre a las 23:00). ``false``
   *  cuando solo el final cruza (e.g. 21:00-23:30, inicio antes del
   *  cierre, fin después). El modal usa esto para no mentir. */
  starts_after_close: boolean;
}

interface PendingOverride {
  context: AfterHoursContext;
  resolve: (acknowledge: boolean) => void;
}

interface State {
  pending: PendingOverride | null;
  open: (context: AfterHoursContext) => Promise<boolean>;
  close: (acknowledge: boolean) => void;
}

export const useAfterHoursOverrideStore = create<State>((set, get) => ({
  pending: null,
  open: (context) =>
    new Promise<boolean>((resolve) => {
      set({ pending: { context, resolve } });
    }),
  close: (acknowledge) => {
    const { pending } = get();
    if (pending) {
      pending.resolve(acknowledge);
      set({ pending: null });
    }
  },
}));
